import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Award, Star, ChevronRight } from 'lucide-react';
export function Achievements() {
  return <div className="w-full bg-slate-50 min-h-screen pt-28 pb-32" data-id="element-109">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-110">
        <div className="mb-24 text-center" data-id="element-111">
          <h1 className="font-serif text-5xl md:text-7xl text-navy-900 mb-8" data-id="element-112">
            Thought Leadership & Intellectual Capital
          </h1>
          <div className="w-32 h-1.5 bg-emerald-500 mx-auto" data-id="element-113"></div>
          <p className="mt-10 text-2xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-114">
            A legacy of rigorous academic contribution and nationally recognized
            excellence in institutional strategy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-115">
          {/* Left Column: Publications */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-116">
            <div className="flex items-center gap-5 mb-12 border-b-2 border-slate-200 pb-6" data-id="element-117">
              <div className="p-3 bg-emerald-100 rounded-lg" data-id="element-118">
                <BookOpen className="w-8 h-8 text-emerald-600" data-id="element-119" />
              </div>
              <h2 className="font-serif text-4xl text-navy-900 font-bold" data-id="element-120">
                Key Publications
              </h2>
            </div>

            <div className="space-y-8" data-id="element-121">
              <div className="bg-white p-10 border border-slate-200 shadow-xl relative overflow-hidden group hover:border-emerald-400 transition-colors" data-id="element-122">
                <div className="absolute top-0 left-0 w-1.5 h-full bg-emerald-500" data-id="element-123"></div>
                <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-emerald-50 text-emerald-700 font-bold text-xs tracking-widest uppercase mb-6 rounded-full" data-id="element-124">
                  <Star size={14} data-id="element-125" /> Upcoming Late-2026
                </div>
                <h3 className="font-serif text-3xl text-navy-900 mb-4 leading-snug group-hover:text-emerald-600 transition-colors" data-id="element-126">
                  Disruption by Design in Higher Education: A Leader's Guide to
                  Accelerated Transformation
                </h3>
                <p className="text-lg text-slate-500 font-medium flex items-center gap-2" data-id="element-127">
                  Published by Routledge{' '}
                  <ChevronRight size={16} className="text-emerald-500" data-id="element-128" />
                </p>
              </div>

              <div className="bg-white p-10 border border-slate-200 shadow-md hover:shadow-xl transition-shadow relative" data-id="element-129">
                <div className="absolute top-0 left-0 w-1.5 h-full bg-slate-300" data-id="element-130"></div>
                <h3 className="font-serif text-2xl text-navy-900 mb-4 leading-snug" data-id="element-131">
                  The Path to Innovation
                </h3>
                <p className="text-lg text-slate-600" data-id="element-132">
                  Strategic frameworks for institutional evolution and
                  structural modernization.
                </p>
              </div>

              <div className="p-10 border border-slate-200 bg-navy-900 text-white shadow-xl relative overflow-hidden" data-id="element-133">
                <div className="absolute right-0 bottom-0 opacity-10 transform translate-x-1/4 translate-y-1/4" data-id="element-134">
                  <BookOpen className="w-64 h-64" data-id="element-135" />
                </div>
                <div className="relative z-10" data-id="element-136">
                  <div className="font-serif text-6xl text-emerald-400 mb-4 font-bold" data-id="element-137">
                    100+
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-138">
                    Peer-Reviewed Publications
                  </h3>
                  <p className="text-lg text-slate-300 leading-relaxed" data-id="element-139">
                    Spanning health policy, institutional governance, clinical
                    integration, and macro-economic development.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Honors */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-140">
            <div className="flex items-center gap-5 mb-12 border-b-2 border-slate-200 pb-6" data-id="element-141">
              <div className="p-3 bg-emerald-100 rounded-lg" data-id="element-142">
                <Award className="w-8 h-8 text-emerald-600" data-id="element-143" />
              </div>
              <h2 className="font-serif text-4xl text-navy-900 font-bold" data-id="element-144">
                Key Laurels
              </h2>
            </div>

            <div className="space-y-8" data-id="element-145">
              <div className="p-10 bg-gradient-to-br from-navy-900 to-navy-800 text-white relative overflow-hidden shadow-2xl border border-navy-700" data-id="element-146">
                <div className="absolute -right-10 -top-10 text-white/5 transform rotate-12" data-id="element-147">
                  <Award className="w-64 h-64" data-id="element-148" />
                </div>
                <div className="relative z-10" data-id="element-149">
                  <div className="inline-block px-4 py-1 bg-emerald-500/20 text-emerald-400 text-xs font-bold tracking-widest uppercase mb-6 border border-emerald-500/30" data-id="element-150">
                    National Recognition
                  </div>
                  <h3 className="font-serif text-4xl mb-6 text-white leading-tight" data-id="element-151">
                    Lifetime Achievement Award
                  </h3>
                  <div className="space-y-2" data-id="element-152">
                    <p className="text-xl text-emerald-400 font-medium" data-id="element-153">
                      National Academy of Medicine
                    </p>
                    <p className="text-base text-slate-400 uppercase tracking-widest" data-id="element-154">
                      Robert Wood Johnson Health Policy Fellowship
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-10 border border-slate-200 bg-white shadow-lg hover:shadow-xl transition-shadow relative group" data-id="element-155">
                <div className="absolute top-0 left-0 w-full h-1.5 bg-emerald-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" data-id="element-156"></div>
                <h3 className="font-serif text-3xl text-navy-900 mb-6 font-bold" data-id="element-157">
                  Cleve Mathews Vision Award
                </h3>
                <p className="text-xl text-slate-700 mb-4" data-id="element-158">
                  For Architecting the ABQ Innovation Ecosystem
                </p>
                <div className="pt-6 border-t border-slate-100" data-id="element-159">
                  <p className="text-sm text-emerald-600 uppercase tracking-widest font-bold" data-id="element-160">
                    NAIOP Commercial Real Estate Association
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}